import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { pricingAssumptionsSearchSchema } from '@/hooks/queries/crt/usePricingAssumptions'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PricingAssumptionsDataTable from './-components/PricingAssumptionsDataTable'
import { CreatePricingAssumptionDialog } from './-components/CreatePricingAssumptionDialog'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/pricing-assumptions/')({
  component: RouteComponent,
  validateSearch: (search) => pricingAssumptionsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('pricingAssumptions.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_pe_pricing_assumptions_create']}>
          <CreatePricingAssumptionDialog />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('pricingAssumptions.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <PricingAssumptionsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
